<div class="dialog-container">
      <!-- Хедер с кнопкой -->
      <div class="dialog-header">
        <h2>Добавление паспортов технологий в реестр КНТП</h2>
        
      </div>

    <mat-dialog-content>
    <div class="content-wrapper">
       <button class="tree-toggle-btn" (click)="toggleTree()">
    <mat-icon>menu</mat-icon>
    <span *ngIf="!isTreeOpen">Выбрать раздел</span>
    <span *ngIf="selectedNode" class="selected-name">{{ selectedNode.name }}</span>
  </button>

      
      <div class="tree-slide-panel" [class.open]="isTreeOpen">
    <div class="tree-panel-content">
      <div class="tree-header">
        <h4>Разделы</h4>
        <button mat-icon-button (click)="closeTree()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="tree-scroll">
            <mat-tree #treeSelector [dataSource]="dataSourceRoot" [treeControl]="treeControlRoot">
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding 
                (click)="selectNode(node)">
                <button mat-icon-button disabled></button>
                {{node.name}}
              </mat-tree-node>
              
              <mat-tree-node *matTreeNodeDef="let node;when: hasChildRoot" matTreeNodePadding 
                (click)="selectNode(node)">
                <button mat-icon-button matTreeNodeToggle 
                  [attr.aria-label]="'Toggle ' + node.name"
                  (click)="$event.stopPropagation()">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControlRoot.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                {{node.name}}
              </mat-tree-node>
             </mat-tree>
      </div>
    </div>
  </div>
      <div class="main-content" [class.shifted]="isTreeOpen">

                
                    <span>
                        <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon"
                            (click)="GetRegistryTable()">
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </span>

                   

                    <span class="flexExpand"></span>

                    

                    <span>
                        <mat-slide-toggle class="example-margin" [(ngModel)]="show_archieved"
                            (change)="GetRegistryTable()">Показать
                            архивные</mat-slide-toggle>
                    </span>
                               

                <!--------RegistryList table-->
                <div class="mat-elevation-z8">
                    <mat-form-field>
                        <mat-label>Фильтр</mat-label>
                        <input matInput placeholder="Фильтр" (keyup)="Filterchange($event)">
                    </mat-form-field>

                    <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">

                        <!-- Checked Column -->
                        <ng-container matColumnDef="Checked">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef><mat-icon>check_box</mat-icon></th>
                            <td mat-cell *matCellDef="let element_table">
                                <mat-checkbox class="example-margin"
                                    (change)="FunctionChecked($event, element_table)"></mat-checkbox>
                            </td>
                        </ng-container>

                        <!-- ID Column -->
                        <ng-container matColumnDef="ID">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>ID</th>
                            <td mat-cell *matCellDef="let element_table"> {{element_table.ID}} </td>
                        </ng-container>

                        <!-- ShortTitle -->
                        <ng-container matColumnDef="ShortTitle">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                Название
                            </th>
                            <td mat-cell *matCellDef="let element_table"> {{element_table.ShortTitle}} </td>
                        </ng-container>

                        <!-- SecurityLevel Column -->
                        <ng-container matColumnDef="SecurityLevel">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                <fa-icon [icon]="faShieldHalved"></fa-icon>
                            </th>
                            <td mat-cell *matCellDef="let element_table"> {{element_table.SecurityLevel}} </td>
                        </ng-container>

                        <!-- ArchiveSign Column -->
                        <ng-container matColumnDef="ArchiveSign">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                <fa-icon [icon]="faBoxArchive"></fa-icon>
                            </th>
                            <td mat-cell *matCellDef="let element_table">
                                <mat-checkbox class="example-margin" [(ngModel)]="element_table.ArchiveSign"
                                    [disabled]="true"></mat-checkbox>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr (click)="getrow(row)" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10,25,100]" showFirstLastButtons>

                    </mat-paginator>

                </div>
                
           
                   </div>
 

        <div style="display: flex;">
            <button mat-raised-button color="primary" [disabled]="selected_registry_array.length===0"
                (click)="AddPassports()">
                Добавить паспортов, шт.: {{selected_registry_array.length}}
            </button>
            
            <button mat-raised-button color="primary" *ngFor="let item of selected_registry_array" (click)="RemoveItemFromList(item)" >
                <span><mat-icon>delete_forever</mat-icon></span>
            </button>
            <button mat-raised-button color="warn" (click)="exit()" style="margin-left: 5px;">Отмена</button>
        </div>
        
    </div>
  </mat-dialog-content>
</div>


